import * as Yup from "yup"

export const coverManagementValidationSchema = Yup.object({
  contentName: Yup.string().max(255).required("Please Enter Cover Name"),
  coverStart: Yup.string().required("Please Enter Cover Start Date"),
  coverEnd: Yup.string().required("Please Enter Cover End Date"),

  coverDesktop: Yup.object()
    .test(
      "is-not-empty-object",
      "Please Upload Cover for Desktop",
      value => value && Object.keys(value).length > 0
    )
    .required("Please Upload Cover for Desktop"),

  coverMobile: Yup.object()
    .test(
      "is-not-empty-object",
      "Please Upload Cover for Mobile",
      value => value && Object.keys(value).length > 0
    )
    .required("Please Upload Cover for Mobile"),

  contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
})
